(() => {
  if (window.__owJoyRewardsInitialized) return;
  window.__owJoyRewardsInitialized = true;
  const observedRoots = new WeakSet();
  const launcherStyleId = 'ow-joy-launcher-visibility';
  let visibilityFrame = 0;
  const syncLauncher = () => {
    visibilityFrame = 0;
    document.querySelectorAll('joy-loyalty-widget').forEach(widget => {
      const root = widget.shadowRoot;
      if (!root) return;
      if (!observedRoots.has(root)) {
        const observer = new MutationObserver(queueLauncherSync);
        observer.observe(root, { childList: true, subtree: true });
        observedRoots.add(root);
      }
      let style = root.getElementById(launcherStyleId);
      if (!style) {
        style = document.createElement('style');
        style.id = launcherStyleId;
        root.append(style);
      }
      const css = '@media(max-width:767px){joy-fab-button,.joy-fab-pure{display:none!important}}';
      if (style.textContent !== css) style.textContent = css;
    });
  };
  const queueLauncherSync = () => {
    if (!visibilityFrame) visibilityFrame = requestAnimationFrame(syncLauncher);
  };
  const launcherObserver = new MutationObserver(queueLauncherSync);
  launcherObserver.observe(document.body, { childList: true, subtree: true });
  customElements.whenDefined('joy-loyalty-widget').then(queueLauncherSync);
  window.addEventListener('joy:ready', queueLauncherSync);
  document.addEventListener('shopify:section:load', queueLauncherSync);
  queueLauncherSync();
  let opening = false;
  const openJoy = () => {
    if (window.location.hash === '#joy-home') {
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    } else {
      window.location.hash = 'joy-home';
    }
    opening = false;
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('a[data-ow-joy-open],a[href="#joy-home"]');
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (opening) return;
    opening = true;
    const drawer = trigger.closest('m-cart-drawer');
    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
      window.setTimeout(openJoy, 350);
    } else if (trigger.closest('#m-menu-drawer.open')) {
      document.querySelector('#m-menu-drawer .m-menu-drawer__backdrop')?.click();
      window.setTimeout(openJoy, 350);
    } else {
      openJoy();
    }
  });


  // Apply events are available on this shop; close through the normal UI button.
  let couponRefreshTimer = 0;
  let couponRefreshRunning = false;
  let couponRefreshPending = false;
  let latestCouponCode = '';
  const wait = ms => new Promise(resolve => window.setTimeout(resolve, ms));
  const closeJoyPanel = () => {
    document.querySelectorAll('joy-loyalty-widget').forEach(widget => {
      const closeButton = widget.shadowRoot?.querySelector('.joy-widget-container.joy-open .joy-close-btn');
      if (closeButton) closeButton.click();
    });
  };
  const refreshCartSections = async (couponCode, { open = true } = {}) => {
    const drawer = document.querySelector('m-cart-drawer');
    const items = document.querySelector('m-cart-drawer m-cart-items')
      || document.querySelector('m-cart-items');
    if (!items || typeof items.getSectionsToRender !== 'function') {
      throw new Error('Minimog cart items are unavailable');
    }
    const sectionName = items.sectionName;
    const countName = items.cartCountSectionName;
    const root = window.Shopify?.routes?.root || '/';
    // Joy's session application does not update Liquid's Ajax cart discounts.
    // Synchronize the successfully applied code using Shopify's Cart API.
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 10000);
    let sections;
    let updatedCart;
    try {
      const currentResponse = await fetch(root + 'cart.js', {
        credentials: 'same-origin', cache: 'no-store', signal: controller.signal
      });
      if (!currentResponse.ok) throw new Error('Could not read current cart');
      const currentCart = await currentResponse.json();
      const codes = (currentCart.discount_codes || [])
        .map(discount => discount.code).filter(code => typeof code === 'string' && code);
      if (!codes.some(code => code.toLowerCase() === couponCode.toLowerCase())) codes.push(couponCode);
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', cache: 'no-store',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        signal: controller.signal,
        body: JSON.stringify({
          discount: codes.join(','),
          sections: [sectionName, countName], sections_url: root + 'cart'
        })
      });
      if (!response.ok) throw new Error('Cart discount synchronization failed: ' + response.status);
      updatedCart = await response.json();
      sections = updatedCart.sections;
    } finally {
      window.clearTimeout(timeout);
    }
    if (!sections || typeof sections[sectionName] !== 'string') {
      throw new Error('Shopify did not render the cart section');
    }
    const parsed = new DOMParser().parseFromString(sections[sectionName], 'text/html');
    const replacements = items.getSectionsToRender().flatMap(section => {
      const parent = document.getElementById(section.id);
      const target = parent?.querySelector(section.selector) || parent;
      if (!target) return [];
      const source = parsed.querySelector(section.selector);
      if (!source) throw new Error('Missing cart fragment: ' + section.selector);
      return [{ target, html: source.innerHTML }];
    });
    if (!replacements.length) throw new Error('No cart fragments found');
    replacements.forEach(({target,html}) => { target.innerHTML = html; });
    if (typeof sections[countName] === 'string') {
      const countDoc = new DOMParser().parseFromString(sections[countName], 'text/html');
      document.querySelectorAll('m-cart-count').forEach(count => {
        if (typeof count.onUpdate === 'function') count.onUpdate(countDoc);
      });
    }
    if (open && drawer && typeof drawer.open === 'function') drawer.open();
    return updatedCart;
  };
  const refreshAfterCoupon = async () => {
    if (couponRefreshRunning) {
      couponRefreshPending = true;
      return;
    }
    couponRefreshRunning = true;
    try {
      do {
        couponRefreshPending = false;
        closeJoyPanel();
        await wait(350);
        await refreshCartSections(latestCouponCode);
      } while (couponRefreshPending);
    } catch (error) {
      console.warn('[OW JOY] Reward-to-cart handoff failed.', error);
    } finally {
      couponRefreshRunning = false;
    }
  };
  window.addEventListener('joy:applyCoupon', event => {
    const code = event.detail?.couponCode;
    if (typeof code !== 'string' || !code.trim()) return;
    latestCouponCode = code.trim();
    window.clearTimeout(couponRefreshTimer);
    couponRefreshTimer = window.setTimeout(refreshAfterCoupon, 100);
  });

  // The Unified Widget's gift path does not emit joy:applyCoupon.
  // Handle its explicit gift request as one transaction, as the working
  // 9Rabbit bridge does: add succeeds -> discount succeeds -> refresh/open.
  let giftRunning = false;
  const giftStatus = (widget, text, error = false) => {
    const panel = widget?.shadowRoot?.querySelector('.joy-widget-container');
    if (!panel) return;
    let message = panel.querySelector('[data-ow-gift-status]');
    if (!message) {
      message = document.createElement('div');
      message.setAttribute('data-ow-gift-status', '');
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      panel.append(message);
    }
    message.textContent = text;
    message.style.cssText = 'position:absolute;left:12px;right:12px;bottom:70px;z-index:10;padding:12px;border-radius:8px;font-size:14px;line-height:1.4;background:' +
      (error ? '#fff1f0;color:#9b1c1c;border:1px solid #e6b4b0' : '#eaf5fa;color:#19345c;border:1px solid #b7d8e8');
    message.hidden = !text;
  };
  window.addEventListener('joy-add-to-cart', event => {
    const widget = event.composedPath().find(node => node?.tagName === 'JOY-LOYALTY-WIDGET');
    const code = event.detail?.code;
    const products = event.detail?.products;
    if (!widget || typeof code !== 'string' || !code.trim() || !Array.isArray(products)) return;
    const desired = new Map();
    for (const product of products) {
      const match = String(product.variantId || '').match(/([0-9]+)$/);
      const quantity = Number(product.quantity || 1);
      if (!match || !Number.isSafeInteger(quantity) || quantity < 1) return;
      const id = Number(match[1]);
      if (!Number.isSafeInteger(id) || id < 1) return;
      desired.set(id, (desired.get(id) || 0) + quantity);
    }
    if (!desired.size) return;
    // Prevent Joy from also adding the same gift / applying it in parallel.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (giftRunning || couponRefreshRunning) return;
    giftRunning = true;
    widget.setAttribute('aria-busy', 'true');
    giftStatus(widget, 'Adding your gift and applying the reward…');
    (async () => {
      const giftController = new AbortController();
      const giftTimeout = window.setTimeout(() => giftController.abort(), 15000);
      try {
        const root = window.Shopify?.routes?.root || '/';
        const current = await fetch(root + 'cart.js', { credentials:'same-origin', cache:'no-store', signal:giftController.signal });
        if (!current.ok) throw new Error('Unable to read the cart. Please try again.');
        const cart = await current.json();
        const additions = [];
        for (const [id, quantity] of desired) {
          const existing = (cart.items || []).filter(item => Number(item.variant_id || item.id) === id)
            .reduce((total,item) => total + Number(item.quantity || 0), 0);
          if (existing < quantity) additions.push({ id, quantity: quantity - existing });
        }
        if (additions.length) {
          const response = await fetch(root + 'cart/add.js', {
            method:'POST', credentials:'same-origin', signal:giftController.signal,
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({ items:additions })
          });
          if (!response.ok) {
            const failure = await response.json().catch(() => ({}));
            throw new Error(typeof failure.description === 'string' ? failure.description :
              'The gift could not be added. Please check stock and try again.');
          }
        }
        const updated = await refreshCartSections(code.trim(), { open:false });
        const applicable = (updated.discount_codes || []).some(discount =>
          discount.code?.toLowerCase() === code.trim().toLowerCase() && discount.applicable);
        if (!applicable) {
          giftStatus(widget, 'The item is in your cart, but this reward could not be applied. Check its conditions and whether another discount prevents combining it. The item is not confirmed free.', true);
          return;
        }
        giftStatus(widget, '');
        closeJoyPanel();
        await wait(350);
        const drawer = document.querySelector('m-cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      } catch (error) {
        giftStatus(widget, error.message || 'Unable to apply this gift reward. Please try again.', true);
        console.warn('[OW JOY] Gift-to-cart handoff failed.', error);
      } finally {
        window.clearTimeout(giftTimeout);
        giftRunning = false;
        widget.removeAttribute('aria-busy');
      }
    })();
  }, true);

})();


